export default "__VITE_ASSET__cd4ee8e5__"